// The game numbers each equipment slot, and the shop keeps one list per slot.
export const SHOP_ITEM_TYPES = [
  { type: 0, key: "frames", commit_name: "SET_FRAMES" },
  { type: 1, key: "wheels", commit_name: "SET_WHEELS" },
  { type: 2, key: "helmet", commit_name: "SET_HELMET" },
  { type: 3, key: "gloves", commit_name: "SET_GLOVES" },
  { type: 5, key: "glasses", commit_name: "SET_GLASSES" },
  { type: 6, key: "hair", commit_name: "SET_HAIR" },
  { type: 7, key: "facialHair", commit_name: "SET_FACIALHAIR" },
  { type: 8, key: "jerseys", commit_name: "SET_JERSEYS" },
  { type: 10, key: "socks", commit_name: "SET_SOCKS" },
  { type: 11, key: "shoes", commit_name: "SET_SHOES" },
  { type: 15, key: "head", commit_name: "SET_HEAD" },
];

export const SHOP_COMMIT_NAMES = SHOP_ITEM_TYPES.map(
  ({ commit_name }) => commit_name,
);
